import { addMediaFromUrl } from 'actions/adminActions'
import { DynamicContentType, MediaType } from 'app/types'
import { link } from 'fs'
import { getMediaUrl } from 'helpers/config'
import { logger } from 'helpers/logger'

export function getMediaLink(mediaLink: string, options: { [key: string]: string } = null) {
    if (options) {
        let extension = null
        let rx = /.*\.([A-Za-z]+)$/g
        try {
            extension = rx.exec(mediaLink)[1]
        } catch (e) {
            logger.error(`Couldn't identify image extension in ${mediaLink}`)
            return
        }
        const linkParts = [getMediaUrl()]

        if (options.mediaTypeId == MediaType.EmailResource) {
            linkParts.push('email')
        } else {
            if (options.app && options.app.meta) {
                linkParts.push('app')
                linkParts.push(options.app.meta.id)
            } else if (options.builder) {
                linkParts.push('builder')
                linkParts.push(options.builder.id)
            } else if (options.organization) {
                linkParts.push('organization')
                linkParts.push(options.organization.id)
            }
        }

        let finalMediaLink = mediaLink
        if (options.suffix) {
            finalMediaLink = (finalMediaLink.replace(`.${extension}`, `${options.suffix}.${extension}`))
        }
        if (options.thumb && extension == 'jpg') {
            linkParts.push('thumbnails')
            finalMediaLink = `${finalMediaLink.replace('.jpg', `_thumb${options.thumbSize ? options.thumbSize : 256}.jpg`)}`
        }
        linkParts.push(finalMediaLink)
        return linkParts.join('/')
    }

    return `${getMediaUrl()}/${mediaLink}`
}

export function getLegacyMediaId(_m, app, builder, organization, allMedia, debug = false) {
    if (!_m) {
        return null
    }
    const { galleryLink, mediaLink, mediaName, index, link, type, id } = _m
    if (type == 2) {
        debug = true
    }
    let ret = null
    let retB = null
    if (_m.mediaId) {
        ret = _m.mediaId
    } if (_m.galleryId) {
        retB = _m.galleryId
        let galleries = null
        if (app) {
            galleries = app.galleries
        } else if (builder) {
            galleries = builder.galleries
        } else if (organization) {
            galleries = organization.galleries
        }
        const gallery = galleries.find((x) => x.id == retB)
        ret = gallery?.media.map((x) => x.mediaId)
    } else if (galleryLink) {
        let galleries = null
        if (app) {
            galleries = app.galleries
        } else if (builder) {
            galleries = builder.galleries
        } else if (organization) {
            galleries = organization.galleries
        }
        const gallery = galleries?.find((x) => x.link == galleryLink)
        if (gallery) {
            if (index != null && index < gallery.media.length) {
                ret = gallery.media[index].mediaId
            } else if (mediaLink != null) {
                ret = gallery.media.find((x) => {
                    const mediaId = x?.mediaId
                    if (mediaId in allMedia && allMedia[mediaId].link.startsWith(mediaLink)) {
                        return true
                    }
                    return false
                })?.mediaId
            } else if (mediaName != null) {
                ret = gallery.media.find((x) => {
                    const mediaId = x?.mediaId
                    if (mediaId in allMedia && allMedia[mediaId].name.startsWith(mediaName)) {
                        return true
                    }
                    return false
                })?.mediaId
            } else {
                retB = gallery.id
                ret = gallery.media.map((x) => x.mediaId)
            }
        }
    } else if (mediaLink) {
        ret = Object.values(allMedia).find((x) => x.link == mediaLink)?.id
    } else if (link && type) {
        let source = app || builder || organization
        if (type == MediaType.Tour) {
            const modelhome = source?.modelhomes.find((x) => x.link == link || x.mediaId == id)
            ret = modelhome.mediaId
        } else if (type == MediaType.Spin) {
            const spin = source.spins.find((x) => x.link == link || x.mediaId == id)
            ret = spin.id
        }
    }
    return { mediaId: ret, galleryId: retB }
}

export function getModelhomeFallbackTours(
    dynamicContent: any[],
    allMedia: { [key: string]: any },
    pageId: string,
): { id: string, name: string, link: string, mediaId: string, subtitle: string, tag: null }[] {
    if (!dynamicContent || !pageId) {
        return []
    }
    const seen = new Set<string>()
    const result: { id: string, name: string, link: string, mediaId: string, subtitle: string, tag: null }[] = []
    const _pageBlocks = dynamicContent.filter((x) => x.pageId === pageId)
    console.log('[getModelhomeFallbackTours] pageId:', pageId, 'all blocks:', dynamicContent.length, 'page blocks:', _pageBlocks.length, 'DynamicContentType.Tour:', DynamicContentType.Tour)
    if (_pageBlocks.length > 0) {
        console.log('[getModelhomeFallbackTours] page block types:', _pageBlocks.map((x) => x.dynamicContentTypeId))
    }
    for (const block of dynamicContent) {
        if (block.pageId !== pageId) {
            continue
        }
        if (block.dynamicContentTypeId !== DynamicContentType.Tour) {
            continue
        }
        if (!block.media) {
            continue
        }
        for (const m of block.media) {
            const mediaId = m.mediaId
            if (!mediaId || seen.has(mediaId)) {
                continue
            }
            const mediaItem = allMedia[mediaId]
            console.log('[getModelhomeFallbackTours] mediaId:', mediaId, 'mediaTypeId:', allMedia[mediaId]?.mediaTypeId, 'expected MediaType.Tour:', MediaType.Tour)
            if (!mediaItem || mediaItem.mediaTypeId !== MediaType.Tour) {
                continue
            }
            seen.add(mediaId)
            result.push({
                id: mediaItem.link,
                name: mediaItem.name || block.title || '',
                link: mediaItem.link,
                mediaId: mediaItem.id,
                subtitle: m.subtitle || block.subtitle || '',
                tag: null,
            })
        }
    }
    return result
}
